export const navigationEnums={
    SEARCH_TEMPLATE_NEWDATA:"searchTemplateNewData",
    GLOBAL_SEARCH:"globalsearch",
    SEARCH_SCROLL_VIEW:"SearchScrollView",
    SEARCH_FULL_VIEW:"SearchFullView",
}
